import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    getDealers: (context, data) => {
        return Axios.post((<any>window).App.routes.Dealer_GetDealers, data, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
    },
    getDealer: (context, data) => {
        return Axios.post((<any>window).App.routes.Dealer_GetDealer, data, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
    },
    getDealerPoints: (context, data) => {
        return Axios.post((<any>window).App.routes.Dealer_GetDealerPoints, data, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
    },
    getLocation: (context, data) => {
        return Axios.get("http://maps.googleapis.com/maps/api/geocode/json?latlng=" + data.lat + "," + data.lng);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};